export const HYDRA_MEMBER = 'hydra:member'
export const HYDRA_TOTAL_ITEMS = 'hydra:totalItems'
